<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="`Hapus perangkat`" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <p class="m-d-8 f-16 f-c-black f-regular">
                        Dengan menghapus perangkat secara permanen, maka outlet yang terintegrasi akan terputus & paket
                        kuota akan hangus.
                    </p>
                    <p class="m-d-0 m-t-4 m-d-8 f-16 f-regular f-c-midgrey">
                        Yakin ingin menghapus perangkat ini?
                    </p>
                    <div class="m-t-4 m-d-8" style="background: #F2F5F7; border-radius: 8px; padding: 8px 12px;">
                        <p class="f-14 f-bold f-c-midgrey m-d-0">
                            Harap diperhatikan:
                        </p>
                        <ul class="p-l-20 f-regular f-14 f-c-midgrey">
                            <li>
                                Perangkat yang terhapus tidak bisa dikembalikan, anda harus melakukan registrasi lagi &
                                mengatur ulang.
                            </li>
                            <li>
                                Jika anda ingin menghubungkan ulang perangkat, silakan klik “scan ulang” di halaman ini.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <label class="m-d-0 d-flex-between-center" style="justify-content: left;" @click="toggleCheck">
                            <SOCheckBox :is-checked="confirmDelete" />
                            <span class="m-l-4">Ya, saya yakin menghapus perangkat ini.</span>
                        </label>
                    </div>
                </div>
            </template>
            <template v-slot:modal-footer>
                <div class="">
                    <div style="margin-bottom: 10px">
                        <SOButton
                            :outline-danger="true"
                            :full="true"
                            :text="'Ya, hapus perangkat ini'"
                            :id="`delete-device`"
                            :disable="!confirmDelete"
                            :loading="isFetching"
                            @action="doDelete"
                        />
                    </div>
                    <div>
                        <SOButton
                            :outline="true"
                            :full="true"
                            :text="'Batal'"
                            :id="'batal-delete-device'"
                            :disable="isFetching"
                            :loading="isFetching"
                            @action="back"
                        />
                    </div>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";

import { moduleName } from "../../store/state";

export default {
    name: "ConfirmDelete",
    components: {
        SOSlotModal,
        SOButton,
        SOCheckBox,
    },
    data() {
        return {
            backLink: "wa_autosender.detail_perangkat",
            modalId: "confirm-delete",
            confirmDelete: false,
        };
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            response: "response",
        }),
        getIdOutlet() {
            return this.$route.params.id_outlet;
        },
    },
    methods: {
        ...mapActions({
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            removeDevice: `${moduleName}/removeDevice`,
            resetListPerangkat: `${moduleName}/resetListPerangkat`,
        }),
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        doDelete() {
            if (this.isFetching) {
                return;
            }
            this.removeDevice({ id_device: this.$route.params.id_device })
                .then((res) => {
                    let { code, data, msg, status } = res.data;
                    if (code === 200 && status) {
                        this.$toast.success(msg);
                        this.resetListPerangkat();
                        this.$router.push({ name: "wa_autosender.daftar_perangkat" });
                    }
                    this.setFetching(false);
                })
                .catch((e) => {
                    this.setFetching(false);
                    this.$toast.error(e);
                });
        },
        toggleCheck() {
            this.confirmDelete = !this.confirmDelete;
        },
    },
};
</script>
